import { i18n } from 'localization'
import { parseDate, parsePerson } from './utils'
import Document from './Document'

export const status = {
	EXECUTED: 'executed',
	ON_GOING: 'processing',
	ON_HOLD: 'processing',
	REMARKED: 'remarked',
	CANCELLED: 'cancelled',
}

const DATE_WITHOUT_SCHEDULE = '2000-01-01T00:00:00.000Z'

export default class Appointment {
	static fromJSON(json) {
		if (!json) return null
		const appointment = new Appointment(json.id, json.requisitionId)
			.withStatus(json.status)
			.withDate(json.dateTime)
			.withSchedule(json.dateTime)
			.withDoctor(json.doctor)
			.withEntity(json.doctor)
			.withMedicalSpecialty(json.medicalSpecialty)
			.withDisability(json.disability, json.currentDisability)
			.withMedicalDiagnosis(json.medicalDiagnosis)
			.withEstablishment(json.establishment)
			.withMedicalObservation(json.medicalObservation)
			.withDocuments(json.documents)
			.withTransport(json.transport)
			.withPreviousAppointment(json.previousAppointment)
			.withCancelMotive(json.cancelMotive)
			.withNonExecutionMotive(json.nonExecutionMotive)
			.withComments(json.comments)

		return appointment
	}

	constructor(id, requisitionId) {
		this.id = id?.toString()
		this.requisitionId = requisitionId
		this.textId = `appointment_${id || ''}`
		this.key = this.textId
	}

	withStatus(json) {
		this.status = json?.value
			? {
					id: json.id,
					value: status[json.value] || 'cancelled',
					description: json.description,
					icon:
						json.value === 'UNKNOWN'
							? 'cancelled'
							: json.value.toLowerCase().replace('_', '-'),
			  }
			: null
		return this
	}

	withDate(dateStr) {
		if (dateStr) {
			this.date = parseDate(dateStr)
		} else {
			this.date = {}
		}
		return this
	}

	withSchedule(dateStr) {
		this.scheduled =
			dateStr && dateStr !== DATE_WITHOUT_SCHEDULE ? true : false

		return this
	}

	withDoctor(json) {
		this.doctor = parsePerson(json)
		return this
	}

	withEntity(json) {
		this.entity = json?.entity?.name || ''
		return this
	}

	withMedicalSpecialty(json) {
		this.medicalSpecialty = json
			? {
					id: json.id,
					name: i18n.translate((json.name || '').trim()),
			  }
			: null
		return this
	}
	withDisability(disabilityJson, currentDisabilityJson) {
		this.disability = disabilityJson
			? {
					id: disabilityJson.id,
					name: i18n.translate((disabilityJson.name || '').trim()),
					abbreviation: i18n.translate(
						(disabilityJson.id || '').trim()
					),
					rate: parseFloat(disabilityJson.disabilityRate) || 0,
					rateStr:
						disabilityJson.disabilityRate &&
						parseFloat(disabilityJson.disabilityRate) > 0
							? `${disabilityJson.disabilityRate}%`
							: '',
					disabilityPercentage:
						disabilityJson?.id === 'ACCD' &&
						parseFloat(
							disabilityJson.clinicalDisabilityPercentage
						) > 0
							? `${disabilityJson.clinicalDisabilityPercentage}%`
							: disabilityJson?.id === 'ITP' &&
							  parseFloat(disabilityJson.disabilityPercentage) >
									0
							? `${disabilityJson.disabilityPercentage}%`
							: null,
			  }
			: null
		this.currentDisability = currentDisabilityJson
			? {
					id: currentDisabilityJson.id,
					name: i18n.translate(
						(currentDisabilityJson.name || '').trim()
					),
					abbreviation: i18n.translate(
						(currentDisabilityJson.id || '').trim()
					),
			  }
			: null
		return this
	}
	withMedicalDiagnosis(json) {
		this.medicalDiagnosis = Array.isArray(json) ? json : []
		return this
	}
	withEstablishment(json) {
		this.establishment = json
			? {
					id: json.id,
					name: json.name,
			  }
			: null
		return this
	}

	withMedicalObservation(text) {
		this.medicalObservation =
			text && text.length ? text.trim().replace(/<br\/>/gi, '\r\n') : ''
		this.text = this.medicalObservation
		return this
	}

	withDocuments(json) {
		this.documents = (json || []).map((doc) => Document.fromJSON(doc))
		if (this.documents) {
			this.documentsOptions = this.documents.map((doc) => ({
				id: doc.id,
				name: doc.type?.name || doc.name,
				value: doc.id,
				text: doc.type?.name || doc.name,
			}))
		}
		this.hasDocuments = !!this.documents.length
		return this
	}
	withTransport(transport) {
		this.transport = transport
		return this
	}
	withPreviousAppointment(previousAppointment) {
		this.previousAppointment = previousAppointment
		return this
	}
	withCancelMotive(cancelMotive) {
		this.cancelMotive = cancelMotive
		return this
	}
	withNonExecutionMotive(nonExecutionMotive) {
		this.nonExecutionMotive = nonExecutionMotive
		return this
	}
	withComments(comments) {
		this.comments = comments && comments.length ? comments : null

		return this
	}
}
